export default {
  slug: "webstorm",
  code: "WS",
  label: "WebStorm",
  isIDE: true,
  krakenDir: "WebStorm",
  thumbnailColor: "#FCF84A",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#FCF84A",
};
